import extend from "extend";
import getJSON from "@/js/libs/getJSON";
import qsa from "1dr-utils/helpers/elsForEach";

const _getElement = function (stringOrDom, findIn) {
  let el = findIn || document;

  if (stringOrDom instanceof HTMLElement) {
    return stringOrDom;
  } else if (typeof stringOrDom === "string") {
    return el.querySelector(stringOrDom);
  } else {
    return false;
  }
};

const maybeExecute = function (cb, thisVar, args) {
  if (typeof cb === "function") {
    if (thisVar) {
      cb.apply(thisVar, args);
    } else {
      cb();
    }
  }
};

const defaults = {
  url: window.location.href,
  submitSelector: '[type="submit"]',

  states: {
    loading: false,
    ready: false,
    disabled: false,
  },

  errorHandler: function (error) {
    console.warn(error);
  },
};

const FormPoster = function (options, loadFormData) {
  this.options = extend({}, defaults, options);

  this.form = _getElement(this.options.form);

  this.ready = false;

  if (typeof loadFormData === "undefined") {
    loadFormData = true;
  }

  if (!this.form) {
    // console.warn( "form '" + this.options.form + "' was not in the document source" );
    return;
  } else {
    this.ready = true;
  }

  if (loadFormData) {
    this.formData = new FormData(this.form);
  } else {
    this.formData = new FormData();
  }

  this._submitHandler = false;
  this._locked = false;
  this.submits = this.form.querySelectorAll(this.options.submitSelector);

  // Ensure that if a button has a name attribute, then its value
  // is passed into the formdata.
  qsa(this.submits, (el) => {
    el.addEventListener("click", () => {
      if (el.getAttribute("name")) {
        this.formData.set(el.getAttribute("name"), el.getAttribute("value"));
      }
    });
  });

  let statesQsa;

  if (this.form && this.submits) {
    statesQsa = [this.submits, this.form];
  } else {
    statesQsa = this.form;
  }

  this.states = {
    loading: () => {
      maybeExecute(this.options.states.loading, this);

      qsa(statesQsa, (el) => {
        el.setAttribute("disabled", "true");
        el.setAttribute("data-state", "loading");
      });
    },
    disabled: () => {
      maybeExecute(this.options.states.disabled, this);

      qsa(statesQsa, (el) => {
        el.setAttribute("disabled", "true");
      });
    },
    ready: () => {
      maybeExecute(this.options.states.ready, this);

      qsa(statesQsa, (el) => {
        el.removeAttribute("disabled");
        el.setAttribute("data-state", "ready");
      });
    },
  };
};

FormPoster.prototype.validateOnSubmitButtons = function (errors) {
  // Listen for button clicks, report errors if needed, but don't
  // preventDefault, allow us to deal with it
  qsa(this.submits, (el) => {
    el.addEventListener("click", () => {
      if (!errors.validate(true)) {
        errors.focusFirstError();
      }
    });
  });
};

FormPoster.prototype.onReady = function (cb) {
  cb.apply(this);
  return this;
};

// For debugging what might be sent:
FormPoster.prototype.logValues = function (d) {
  var _d = d instanceof FormData ? d : this.formData;

  for (var pair of _d.entries()) {
    console.log(pair[0] + ":", pair[1]);
  }

  return this;
};

FormPoster.prototype.scrapefields = function (selector) {
  var formData = this.formData;
  // Find everything with data-form of the same form id:
  qsa(selector, (el) => {
    var type = el.getAttribute("type");
    var name = el.getAttribute("name");

    if (!name) {
      return;
    }

    var appendOrSet = function () {
      // Ensure fieldName[] is appended rather than replaced...
      if (name.substring(name.length - 2) == "[]") {
        formData.append(el.getAttribute("name"), el.value);
      } else {
        formData.set(el.getAttribute("name"), el.value);
      }
    };

    if (type === "checkbox" || type === "radio") {
      if (el.checked) {
        // If you want to send a 'falsey' value like an explicit "0",
        // ensure a preceding hidden field is there. This will overwrite
        // the hidden value as we use set and not append.
        appendOrSet();
      }
    } else {
      appendOrSet();
    }
  });

  return this;
};

FormPoster.prototype.updateFormValues = function (clear) {
  if (!this.form) {
    console.warn("Tried to update but the form does not exist");
    return;
  }

  var formData = new FormData(this.form);

  if (clear) {
    this.formData = formData;
  }

  for (var pair of formData.entries()) {
    // Ensure fieldName[] is appended rather than replaced...
    if (pair[0].substring(pair[0].length - 2) == "[]") {
      this.formData.append(pair[0], pair[1]);
    } else {
      this.formData.set(pair[0], pair[1]);
    }
  }

  return this;
};

// FormPoster.prototype.lockPosting = function() {
// 	this._locked = true;
// };

// FormPoster.prototype.unlockPosting = function() {
// 	this._locked = false;
// };

FormPoster.prototype.onSubmitClick = function (cb) {
  qsa(this.submits, (el) => {
    el.addEventListener("click", (e) => {
      cb.apply(this, [el, e]);
    });
  });
};

FormPoster.prototype.onSubmit = function (cb) {
  if (!this.form) {
    return;
  }

  // Remove a previous...
  if (this._submitHandler) {
    this.form.removeEventListener("submit", this._submitHandler);
  }

  // add a new.
  this._submitHandler = cb.bind(this);
  this.form.addEventListener("submit", this._submitHandler);

  return this;
};

FormPoster.prototype.post = function (onSuccess, data, onError) {
  if (!this.form) {
    console.warn("Tried to post but the form does not exist");
    return;
  }

  onError = onError || this.options.errorHandler;

  let toPost = data || this.formData;

  // this.logValues( toPost );

  getJSON(
    this.options.url,
    toPost,
    (json) => {
      onSuccess.apply(this, [json]);
    },
    (error) => {
      onError(error);
    },
  );

  return this;
};

export default FormPoster;
